import EventEmitter from "eventemitter3";

export const EventBus = new EventEmitter();

export const EVENTS = {
  // Group related. Used by sidebar groups tree manipulation
  CURRENT_GROUP_UPDATED: "CURRENT_GROUP_UPDATED",
  NEW_GROUP_ADDED: "NEW_GROUP_ADDED",
  GROUP_RENAMED: "GROUP_RENAMED",
  GROUP_REMOVED: "GROUP_REMOVED",
  GROUP_UPDATED: "GROUP_UPDATED",
  GROUP_MOVED: "GROUP_MOVED",
  GROUP_ATTRS_UPDATED: "GROUP_ATTRS_UPDATED",

  // Pagination
  LOAD_MORE_MEMBERS: "LOAD_MORE_MEMBERS",
  LOAD_MORE_TEAMS: "LOAD_MORE_TEAMS",

  // Members related.
  UPDATE_PERSON_AND_GROUPS: "UPDATE_PERSON_AND_GROUPS",

  // Sidebar related
  SIDEBAR_STATUS_CHANGED: "SIDEBAR_STATUS_CHANGED",

  // Tags navigation
  CURRENT_TAG_UPDATED: "CURRENT_TAG_UPDATED",

  // Active tenant updated
  ACTIVE_TENANT_UPDATED: "ACTIVE_TENANT_UPDATED",

  // Storage changed
  STORAGE_CHANGED: "STORAGE_CHANGED",

  // Side navigation
  SIDE_NAV_PINNED_ITEMS_UPDATED: "SIDE_NAV_PINNED_ITEMS_UPDATED",

  // AI chat selected
  AI_DASHBOARD_SELECTED: "AI_DASHBOARD_SELECTED",
};

export default EventBus;
